// Libs
import React from "react";

// Utils
import { useFormatOptions } from "src/hooks";
import { type DomainKeyEnum, useDomain } from "..";
import type { Domain } from "../Domain";
import type { DomainType } from "../domains.config";

type ExtractDT<T> = T extends Domain<infer DT> ? DT : unknown;

interface DomainDisplayProps<K extends DomainKeyEnum> {
    domainKey: DomainKeyEnum;
    value: ExtractDT<DomainType[K]>;
    variant?: "standard" | "short";
}

export function DomainDisplay<K extends DomainKeyEnum>({
    domainKey,
    value,
    variant = "standard",
}: DomainDisplayProps<K>): JSX.Element {
    const domain = useDomain(domainKey);

    if (variant === "short" && !domain.displayShortFormatter) {
        console.error(`DomainField - Variant short not supported for the domain ${domainKey}`);
        return null;
    }

    const DisplayComponent = domain.DisplayComponent ?? React.Fragment;
    const formatter: Domain["displayFormatter"] =
        variant === "standard" ? domain.displayFormatter : domain.displayShortFormatter;

    const formatOptions = useFormatOptions();

    return (
        <DisplayComponent>
            <>{formatter?.(value as unknown as any, formatOptions) ?? value}</>
        </DisplayComponent>
    );
}
